/* Stylesheets */
import './scss/vendors/bootstrap.scss'; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
// import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
import './scss/vendors/energy-saver.scss';
import './scss/fonts.scss';
import './scss/style.scss';

/* Scripts */
import { Offcanvas } from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
import { formatGeneral, formatDate, formatNumeral } from 'cleave-zen';
// import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// import { Navigation, Pagination, A11y, Autoplay, Mousewheel } from 'swiper/modules';
// const swiperTranslations = {
//     firstSlideMessage: `Questa è la prima slide`,
//     lastSlideMessage: `Questa è l'ultima slide`,
//     nextSlideMessage: `Vai alla prossima slide`,
//     paginationBulletMessage: `Vai alla slide {{index}}`,
//     prevSlideMessage: `Vai alla slide precedente`,
//     slideLabelMessage: `{{index}} di {{slidesLength}}`
// } // Oggetto da passare alla proprietà a11y: { ...options, ...swiperTranslations } dell'istanza Swiper - ref: https://docs.google.com/presentation/d/1dhMLaonvwWgX0t-fAxPU4PubI_u6QTrl10IfM6Badng/edit?slide=id.g3a1f0c75b34_0_0#slide=id.g3a1f0c75b34_0_0

import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
// import { faFreeS } from '@fortawesome/free-solid-svg-icons';
// import { faFreeR } from '@fortawesome/free-regular-svg-icons';
// import { faSpinner, faUpload, faCircleInfo, faEye, faEyeSlash, faFile, faUniversalAccess, faHouse } from '@fortawesome/pro-solid-svg-icons';
import { faUpFromBracket } from '@fortawesome/pro-regular-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { faCoffeeBeans, faReceipt, faGift, faSuitcase, faArrowRightToBracket, faArrowLeftToBracket } from '@fortawesome/pro-light-svg-icons';
// import { faProT } from '@fortawesome/pro-thin-svg-icons';
// import { faProD } from '@fortawesome/pro-duotone-svg-icons';
// import { faDuotoneR } from '@fortawesome/duotone-regular-svg-icons';
// import { faDuotoneL } from '@fortawesome/duotone-light-svg-icons';
// import { faDuotoneT } from '@fortawesome/duotone-thin-svg-icons';
// import { faSharpS } from '@fortawesome/sharp-solid-svg-icons';
// import { faSharpR } from '@fortawesome/sharp-regular-svg-icons';
// import { faSharpL } from '@fortawesome/sharp-light-svg-icons';
// import { faSharpT } from '@fortawesome/sharp-thin-svg-icons';
// import { faSharpD } from '@fortawesome/sharp-duotone-solid-svg-icons';
// import { faSharpDR } from '@fortawesome/sharp-duotone-regular-svg-icons';
// import { faSharpDL } from '@fortawesome/sharp-duotone-light-svg-icons';
// import { faSharpDT } from '@fortawesome/sharp-duotone-thin-svg-icons';
// import { faFree } from '@fortawesome/fontawesome-free';
// import { faPro } from '@fortawesome/fontawesome-pro';
library.add(faCoffeeBeans, faReceipt, faGift, faSuitcase, faArrowRightToBracket, faArrowLeftToBracket, faUpFromBracket, faCircleInfo);
// library.add(faDuotoneR, faDuotoneL, faDuotoneT);
// library.add(faSharpS, faSharpR, faSharpL, faSharpT, faSharpD, faSharpDR, faSharpDL, faSharpDT);
// library.add(faFacebookF, faInstagram, faCircleInfo, faSpinner, faUpload, faEye, faEyeSlash, faFile, faUniversalAccess, faHouse);
dom.i2svg();

// import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
// import { faSpinner, faUpload, faCircleInfo, faEye, faEyeSlash, faFile, faUniversalAccess, faHouse } from '@fortawesome/pro-solid-svg-icons';
// library.add(faFacebookF, faInstagram, faCircleInfo, faSpinner, faUpload, faEye, faEyeSlash, faFile, faUniversalAccess, faHouse);
// dom.i2svg();

import EnergySaver from './js/vendors/energy-saver';

const energyS = new EnergySaver({
    enableZeroImpact: false
    // enableZeroImpactTarget: "#zeroimpact"
});


/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

/* Variables and functions */
const offcanvasNav = document.getElementById('offcanvasNav');
const isDebug = process.env.NODE_ENV !== 'production';
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

// Scroll to section
const scrollToSection = (id) => {
    let anchor = document.querySelector(`[data-anchor="${id}" ]`);
    let headerHeight = document.querySelector('header').offsetHeight;
    let anchorPositionY = anchor?.getBoundingClientRect().top;
    window.scrollBy(0, anchorPositionY-headerHeight);

    if (offcanvasNav.classList.contains('show')) {
        let offcanvasInstance = Offcanvas.getInstance(offcanvasNav);
        offcanvasInstance.hide();
    }
    if (window.history.pushState) {
        window.history.pushState(null, null, window.location.pathname + window.location.search);
    } else {
        window.location.hash = '';
    }
}

// Cleave
const initCleave = () => {
    const Input_Cap = document.getElementById('Input_Cap');
    Input_Cap?.addEventListener('input', (e) => {
        Input_Cap.value = formatGeneral(e.target.value, {
            blocks: [5],
            numericOnly: true
        });
    });

    const Input_Telefono = document.getElementById('Input_Telefono');
    Input_Telefono?.addEventListener('input', (e) => {
        Input_Telefono.value = formatGeneral(e.target.value, {
            blocks: [10],
            numericOnly: true
        });
    });

    const Input_DataDiNascita = document.getElementById('Input_DataDiNascita');
    Input_DataDiNascita?.addEventListener('input', (e) => {
        Input_DataDiNascita.value = formatDate(e.target.value, {
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
        });
    });

    const Input1_Data = document.getElementById('Input1_Data');
    Input1_Data?.addEventListener('input', (e) => {
        Input1_Data.value = formatDate(e.target.value, {
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
        });
    });
    const Input2_Data = document.getElementById('Input2_Data');
    Input2_Data?.addEventListener('input', (e) => {
        Input2_Data.value = formatDate(e.target.value, {
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
        });
    });

    const Input1_Ora = document.getElementById('Input1_Ora');
    Input1_Ora?.addEventListener('input', (e) => {
        Input1_Ora.value = formatGeneral(e.target.value, {
            blocks: [2, 2],
            delimiter: ':'
        });
    });

    const Input1_Numero = document.getElementById('Input1_Numero');
    Input1_Numero?.addEventListener('input', (e) => {
        Input1_Numero.value = formatGeneral(e.target.value, {
            blocks: [4, 4],
            delimiter: '-',
            numericOnly: true
        });
    });
    // const Input2_Numero = document.getElementById('Input2_Numero');
    // Input2_Numero?.addEventListener('input', (e) => {
    //     Input2_Numero.value = formatGeneral(e.target.value, {
    //         blocks: [8],
    //         numericOnly: true
    //     });
    // });

    const Input1_Importo = document.getElementById('Input1_Importo');
    Input1_Importo?.addEventListener('input', (e) => {
        const el = e.target; // HTMLInputElement
        el.value = formatNumeral(el.value, {
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,           // max 2 decimali
            numeralThousandsGroupStyle: 'none'
        });
    });
    const Input2_Importo = document.getElementById('Input2_Importo');
    Input2_Importo?.addEventListener('input', (e) => {
        const el = e.target; // HTMLInputElement
        el.value = formatNumeral(el.value, {
            numeralDecimalMark: ',',
            numeralDecimalScale: 2,           // max 2 decimali
            numeralThousandsGroupStyle: 'none'
        });
    });
}

// Check page scroll
let scrollTop;
document.addEventListener("scroll", (event) => {
    scrollTop = (window.scrollY !== undefined) ? window.scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop; 
});

// Menu
const initMenu = () => {
    let hash = window.location.hash;
    if (hash) {
        scrollToSection(hash.substring(1));
    }
    window.addEventListener('hashchange', () => {
        hash = window.location.hash;
        scrollToSection(hash.substring(1));
    });

    offcanvasNav.addEventListener('show.bs.offcanvas', event => {
        setTimeout(() => {
            // document.querySelector('.main-container').classList.add('menu-is-active');
        }, 200);
    });
    offcanvasNav.addEventListener('hide.bs.offcanvas', event => {
        setTimeout(() => {
            // document.querySelector('.main-container').classList.remove('menu-is-active');
        }, 150);
    });
    window.onscroll = () => {
        if (document.querySelector('header')){
            if(scrollTop > 1){
                // document.querySelector('header .logo-link').removeAttribute('tabindex');
                document.querySelector('header').classList.add('is-scrolled');
            } else {
                // document.querySelector('header .logo-link').setAttribute('tabindex', '-1');            
                document.querySelector('header').classList.remove('is-scrolled');
            }
        }
    };
}

// initPwdVisibility
const initPwdVisibility = () => {
    let btnPwdVisible = document.querySelectorAll('.btn-show-hide-pwd');
    btnPwdVisible.forEach(btn => {
        btn.addEventListener('click', function () {
            let thisInput = btn.parentElement.querySelector('input');
            let thisType = thisInput.getAttribute('type');            
            thisInput.setAttribute('type', thisType === 'password' ? 'text' : 'password');
            this.setAttribute('aria-label', thisType === 'password' ? 'Clicca qui per nascondere la password' : 'Clicca qui per mostrare la password');
            if (thisType === 'password') {
                this.querySelector('svg.icon-on').classList.add('d-none');
                this.querySelector('svg.icon-off').classList.remove('d-none');
            } else {
                this.querySelector('svg.icon-on').classList.remove('d-none');
                this.querySelector('svg.icon-off').classList.add('d-none');
            }
        });   
    });    
}

// Fetch all the forms we want to apply custom Bootstrap validation styles to
const initFormValidation = () => {
    const forms = document.querySelectorAll('.needs-validation');
    if (forms) {
        Array.from(forms).forEach(form => {

            let allInputs = form.querySelectorAll('input, select, textarea');
            allInputs.forEach(function (el) {
                el.addEventListener('change', function (event) {
                    if (el.checkValidity()) {
                        el.removeAttribute('aria-invalid');
                    } else {
                        el.setAttribute('aria-invalid', 'true');
                    }
                });
            });

            form.addEventListener('submit', e => {
                
                form.classList.add('was-validated');

                let validFields = form.querySelectorAll('*:valid');
                let invalidFields = form.querySelectorAll('*:invalid');
                validFields.forEach(function (validField) {
                    validField.removeAttribute('aria-invalid');
                });
                invalidFields.forEach(function (invalidField) {
                    invalidField.setAttribute('aria-invalid', 'true');
                });

                if (!form.checkValidity()) {
                    e.preventDefault()
                    e.stopPropagation()
                    invalidFields[0].focus();
                    document.querySelectorAll('.btn-show-hide-pwd').forEach(btn => {
                        const input = btn.closest('form')?.querySelector('input.password');
                        if (input) {
                            btn.style.setProperty('max-height', input.scrollHeight + 2 + 'px');
                        }
                    });
                } else {
                    e.submitter.classList.add('d-none');
                    // Find the next element with btn-loading class after e.submitter
                    let nextBtnLoading = e.submitter.nextElementSibling;
                    while (nextBtnLoading && !nextBtnLoading.classList.contains('btn-loading')) {
                        nextBtnLoading = nextBtnLoading.nextElementSibling;
                    }
                    nextBtnLoading.classList.remove('d-none');
                    const loadingLayer = document.querySelector(".loading-layer");
                    if (loadingLayer) {
                        loadingLayer.style.display = "block";
                    }
                    document.body.style.overflow = 'hidden';
                }
            }, false);
        });
    }
}

// Upload loading
const showUploadLoading = (target, type) => {
    let loader = document.querySelector(target);
    let btnToHide = document.querySelector('#fakeBtnUpload-' + type);
    if (loader) {
        loader.classList.remove('d-none');
    }
    if (btnToHide) {
        btnToHide.classList.add('d-none');
    }
    const loadingLayer = document.querySelector(".loading-layer");
    if (loadingLayer) {
        loadingLayer.style.display = "block";
    }
};
const hideUploadLoading = (target, type) => {
    let loader = document.querySelector(target);
    let btnToShow = document.querySelector('#fakeBtnUpload-' + type);
    if (loader) {
        loader.classList.add('d-none');
    }
    if (btnToShow) {
        btnToShow.classList.remove('d-none');
    }
    const loadingLayer = document.querySelector(".loading-layer");
    if (loadingLayer) {
        loadingLayer.style.display = "none";
    }
};

/* Ready callback function */
ready(() => {
    initWebpackVersion();
    initCleave();
    initMenu();
    initFormValidation();
    initPwdVisibility();
});

window.scrollToSection = scrollToSection;
window.showUploadLoading = showUploadLoading;
window.hideUploadLoading = hideUploadLoading;
